'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:ResetPasswordCtrl
 * @description
 * # ResetPasswordCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
    .controller('ResetPasswordCtrl', ['$scope', '$location', 'Session', function ($scope, $location, Session) {

        let queryStringParams = $location.search();

        $scope.token = queryStringParams.token ?? '';
        $scope.username = queryStringParams.username ?? '';

      if (!$scope.token)
      {
        $scope.errMsgs=['No token specified'];
      }
      else if (!$scope.username)
      {

      }else {
        $scope.errMsg=[];
      }

        $scope.passwordFieldChanged = function () {
            $scope.errMsgs = [];
        }

      $scope.successMsg = '';
      $scope.invalidToken = false;


      $scope.resetPassword=function (token, username, password, confirmPassword) {
          Session.resetPassword(token, username, password, confirmPassword).then(function (response) {
              if (response.data.Changed) {
                  $scope.errMsgs = [];
                  $scope.successMsg = 'Password successfully changed';
              }
              else {
                  $scope.errMsgs = response.data.Errors;
                  $scope.invalidToken = response.data.InvalidToken;
                  $scope.successMsg = '';
              }
          }, function () {
              $scope.successMsg = '';
              $scope.errMsgs = ['Password not changed'];
              $scope.invalidToken = true;
          });
      };

  }]);
